import type { HandleClientError } from "@sveltejs/kit";

import { initDatadogObservability } from "$lib/core/datadog-rum";
import { generateErrorId } from "$lib/core/error";

initDatadogObservability();

export const handleError: HandleClientError = async ({
  error,
  status,
  message,
}) => {
  const errorId = generateErrorId();

  if (status === 404) {
    return {
      message: "Not found",
      errorId,
    };
  }

  console.error(`Uncaught ${status} error (${errorId}): ${message}`);
  console.error(error);

  return {
    message,
    errorId,
  };
};
